import { useTranslations } from "next-intl";

import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";


interface IObjectProps extends React.ComponentProps<"textarea"> {
    isPending: boolean;
}

export const Object = ({ isPending, ...props }: IObjectProps) => {
    const t = useTranslations("expense");

    return (
        <FormItem className="flex flex-col items-center justify-between md:flex-row">
            <FormLabel className="text-lg">{t("object")} :</FormLabel>
            <FormControl className="w-full md:w-1/2">
                <Textarea
                    disabled={ isPending }
                    className="resize-vertical"
                    { ...props }
                />
            </FormControl>
            <FormMessage />
        </FormItem>
    );
};